import React from 'react';

function About() {
  return (
    <section className="page">
      <h1>You</h1>
      <p>A short personal introduction and story will go here.</p>
    </section>
  );
}

export default About;
